/* Colors also set in App.css */
export const colors = {
    primary: "#3E3479",
    primaryBackground: "#F1F0F6",

    offWhite: "#FCFCFF",
    darkGrey: "#717171",
    black: "#000000",
};
